export const positiveNumericRegex = new RegExp(/^[0-9]+$/);
